import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=ff879378&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports